// Imports
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useAppSelector } from '../../../../../../shareables/foundation/front-end/redux/hooks';
import Heading from './heading';


// Define the accepted props
interface Props {
	children: string;
	documentTitle?: string;
	appendCommunityName?: boolean;
	editPageDetails?: {
		pageTypeID: number;
		pageID: number;
	};
	linkTo?: string;
}


// Function component
const PageTitle = React.forwardRef<HTMLHeadingElement, Props>(
	({ children, documentTitle, appendCommunityName = true, editPageDetails, linkTo }, ref) => {
		// Use Redux functionality
		const communityName = useAppSelector((state) => state.self.website?.communityName);
		
		
		// Determine the full document title
		const titleText = documentTitle ?? children;
		const fullTitle = appendCommunityName && communityName ? `${titleText} | ${communityName}` : titleText;
		
		
		// Return JSX
		return (
			<React.Fragment>
				<Helmet title={fullTitle} />
				<Heading ref={ref} editPageDetails={editPageDetails} linkTo={linkTo}>
					{children}
				</Heading>
			</React.Fragment>
		);
	}
);


// @ts-ignore: displayName does exist
PageTitle.displayName = 'PageTitle';

export default PageTitle;
